import React, { PureComponent } from 'react';
import { TextField, MenuItem } from '@mui/material';
import DialogWrapper from '../../../common/components/DialogWrapper/DialogWrapper';

class AddUserDialog extends PureComponent {
  render() {
    return (
      <DialogWrapper
        onClickCancel={this.props.onClickCancel}
        onClickMainAction={this.props.onClickMainAction}
        open={this.props.open}
        title="Assign users"
        disableMainAction={this.props.disableMainAction || this.props.assignableUsers.length === 0}
      >
        {this.props.assignableUsers.length > 0 ? (
          <TextField
            variant="standard"
            select={true}
            label="Select a user"
            value={this.props.selectedUserId}
            onChange={(event) => this.props.handleSelectedUser(event.target.value)}
            style={{ width: '100%' }}
            margin="normal"
            data-qa="qa-assign-user-field"
          >
            {this.props.assignableUsers.map((user) => (
              <MenuItem key={user.UserEntityId} value={user.UserEntityId}>
                {`${user.Username}, ${user.Email}`}
              </MenuItem>
            ))}
          </TextField>
        ) : (
          <div>No available users for this region.</div>
        )}
      </DialogWrapper>
    );
  }
}

export default AddUserDialog;
